/**** mgt.Driver */

const config = {
  schema: 'mgt',
  table: 'Driver',
  title: 'Сотрудники',
  elemsOnPage: 10,
  connections: {
    depots: {
      schema: 'mgt',
      table: 'Depot',
      index: 'depot_id',
      fields: ['depot_name'],
      format: (elem: any) => elem['depot_name'],
    },
    departments: {
      schema: 'mgt',
      table: 'Department',
      index: 'td_id',
      fields: ['td_name'],
      format: (elem: any) => elem['td_name'],
    },
  },
  fields: [
    {
      name: 'driver_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true,
    },
    {
      name: 'last_name',
      title: 'Фамилия',
      type: 'text',
      required: true,
      hide: true,
    },
    {
      name: 'first_name',
      title: 'Имя',
      type: 'text',
      required: true,
      hide: true,
    },
    {
      name: 'middle_name',
      title: 'Отчество',
      type: 'text',
      required: false,
      hide: true,
    },
    {
      name: 'depot_id',
      title: 'Филиал',
      type: 'number',
      required: false,
      connection: 'depots',
      link: 'park'
    },
    {
      name: 'table_number',
      title: 'Табельный номер',
      type: 'number',
      required: true,
    },
    {
      name: 'td_id',
      title: 'Территориальный отдел',
      type: 'number',
      required: false,
      connection: 'departments',
      link: 'department'
    },
    {
      name: 'start_date',
      title: 'Дата начала работы',
      type: 'date',
      required: false,
    },
    {
      name: 'end_date',
      title: 'Дата окончания работы',
      type: 'date',
      required: false,
    },
  ],
  makeTitle: (elem: any, connections: { [key: string]: any }): string => {
    return `${elem['last_name']} ${elem['first_name']} ${elem['middle_name'] || ''}`;
  },
  makeAdditional: (elem: any, connections: { [key: string]: any }): string => {
    const td =
    connections &&
    connections['departments'] &&
      connections['departments'].find((dp: any) => dp['td_id'] === elem['td_id']);
    return `Табельный номер: ${elem['table_number'] || '-'}; Территориальный отдел: ${td && td['td_name'] || '-'}`;
  },
  defaultSort: {
    field: 'driver_id',
    direction: 'desc',
  },
};

export default config;
